import { render, staticRenderFns } from "./MessageApp.vue?vue&type=template&id=074d850e&scoped=true&"
import script from "./MessageApp.vue?vue&type=script&lang=js&"
export * from "./MessageApp.vue?vue&type=script&lang=js&"
import style0 from "./MessageApp.vue?vue&type=style&index=0&id=074d850e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d850e",
  null
  
)

export default component.exports